import { MoreHorizontal, MessageCircle, Send, ThumbsUp } from "lucide-react";
import { getImageURLBasedOnEvent } from "constants/media";
import { truncateText } from "./YoutubePostPreview";

const FacebookPostPreview = ({ selectedEvent, title }) => {
  const imageURL = getImageURLBasedOnEvent(selectedEvent);

  return (
    <div className="w-full h-[full] bg-[white] border rounded-[1vh] shadow-sm p-[2vh] my-[1vh] max-h-[100vh]">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-[1vh]">
          <div className="w-[5vh] h-[5vh] bg-blue-200 rounded-full flex items-center justify-center text-blue-500 font-bold text-[2vh]">
            S
          </div>
          <div className="text-[2vh]">
            <div className="font-semibold text-gray-800">Soomuch.ai</div>
            <div className="text-[1.5vh] text-gray-500">
              Suggested for you · May 15 · 🌐
            </div>
          </div>
        </div>
        <div className="text-gray-400 text-[2vh] font-bold">
          <MoreHorizontal size="2.5vh" />
        </div>
      </div>

      {/* Content */}
      <div className="text-[1.8vh] text-gray-800 mt-[2vh]">
        {truncateText(title, 50)}
      </div>

      {/* Image */}
      <div className="mt-[2vh]">
        <img
          src={imageURL}
          alt="Facebook Post"
          className="w-full h-[36vh] object-contain rounded-[1vh]"
        />
      </div>

      {/* Reactions */}
      <div className="flex items-center justify-between text-[1.4vh] text-gray-500 mt-[1.2vh] px-[0.5vh]">
        <div>
          <span className="text-blue-600">👍</span> Ankit and 77K others
        </div>
        <div>💬 2K comments</div>
      </div>

      <hr className="my-[1vh] border-gray-400" />

      {/* Actions */}
      <div className="flex justify-around text-[1.5vh] text-gray-500 font-medium">
        <button className="flex items-center gap-[0.8vh] hover:text-blue-600">
          <ThumbsUp className="w-[2vh] h-[2vh]" /> Like
        </button>
        <button className="flex items-center gap-[0.8vh] hover:text-blue-600">
          <MessageCircle className="w-[2vh] h-[2vh]" /> Comment
        </button>
        <button className="flex items-center gap-[0.8vh] hover:text-blue-600">
          <Send className="w-[2vh] h-[2vh]" /> Share
        </button>
      </div>
    </div>
  );
};

export default FacebookPostPreview;
